import React, { FunctionComponent } from 'react';
import { Icon, Label, Popup } from 'semantic-ui-react';
import { formatDate } from 'utils';
import { Review } from '../types/review.type';
import {
  getReviewReplyStatus,
  reviewReplyStatusLabels,
} from '../utils/getReviewReplyStatus';
import { ReviewHeader } from './ReviewHeader';
import { ReviewMeta } from './ReviewMeta';

const getReviewReplyStatusLabel = (review: Review): React.ReactElement => {
  const replyStatus = getReviewReplyStatus(review);

  if (replyStatus === 'none') {
    return <Label color="grey">Aucune</Label>;
  }

  const { text, color } = reviewReplyStatusLabels[replyStatus];

  if (replyStatus === 'unpublished') {
    return (
      <Popup
        content={review.isSpam ? 'Avis spam' : 'Avis refusé'}
        trigger={<Label color={color}>{text}</Label>}
      />
    );
  }

  return <Label color={color}>{text}</Label>;
};

type ReviewReplyHeaderProps = {
  review: Review;
};

export const ReviewReplyHeader: FunctionComponent<ReviewReplyHeaderProps> = ({
  review,
}) => (
  <ReviewHeader
    title="Réponse du pro"
    bold={false}
    labels={getReviewReplyStatusLabel(review)}
    meta={
      review.replyDate ? (
        <ReviewMeta>
          <span>
            <Icon name="calendar alternate outline" />
            {formatDate(review.replyDate)}
          </span>
        </ReviewMeta>
      ) : null
    }
  />
);
